import { sidebarMenus } from '../constants'
import Item from './Item'
import React from 'react'

interface MenuProps {
    hiddenText?: boolean
}

const Menu: React.FC<MenuProps> = ({ hiddenText = false }) => {
    return (
        <div className="flex items-center w-full">
            <div
                className={`w-full md:mt-4 mt-0 md:flex-col flex flex-row flex-1 overflow-hidden mr-0`}
            >
                {sidebarMenus?.map((sidebar, i) => (
                    <Item
                        hiddenText={hiddenText}
                        size="medium"
                        sidebar={sidebar}
                        key={i}
                    />
                ))}
            </div>
        </div>
    )
}

export default Menu
